import axios from 'axios'
import { CsrfToken } from '../../common/CsrfToken'

export const getCsrfToken = async (): Promise<boolean> => {
  const res = await axios.get<CsrfToken>(
    `${process.env.REACT_APP_API_URL}/csrftoken`,
    {
      withCredentials: true,
    },
  )

  if (res.data.csrf_token) {
    axios.defaults.headers.common['X-CSRF-Token'] = res.data.csrf_token
    return true
  }

  return false
}
